import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { get, put } from "../../../../utils/api";
import DynamicTable from "../../../Common/CommonDynamicTable";
import styles from "../../../../styles/brsr/general.module.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate, useParams } from "react-router-dom";
import style from "../../../../styles/brsr/general.module.css";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import DeleteRowDialog from "../../../Common/DeleteRowDialog";
import BRSRFile from "../../../Common/BRSRFile";

const LeadershipIndicator = ({
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [rowToDelete, setRowToDelete] = useState({ index: null, table: null });
  const [modalupload, setModalUpload] = useState({
    socialImpactAssessmentsDoc: false,
    csrProjectsInAspirationalDistrictsDoc: false,
    procurementPolicyDoc: false,
    traditionalKnowledgeIntellectualPropertiesDoc: false,
    correctiveActionsForAdverseOrdersDoc: false,
    beneficiariesOfCSRProjectsDoc: false,
  });
  const [formData, setFormData] = useState({
    socialImpactAssessments: [
      {
        // serialNumber: 1,
        details: "",
        correctiveActionTaken: "",
      },
    ],
    csrProjectsInAspirationalDistricts: [
      {
        // serialNumber: 1,
        state: "",
        aspirationalDistrict: "",
        amountSpent: "",
      },
    ],
    procurementPolicy: {
      action: "yes",
      vulnerableGoupProcure: "",
      totalProcurementByValue: "",
    },
    traditionalKnowledgeIntellectualProperties: [
      {
        // serialNumber: 1,
        ipBasedOnTraditionalKnowledge: "",
        ownedAcquired: "",
        benefitShared: "",
        basisOfCalculatingBenefitShare: "",
      },
    ],
    correctiveActionsForAdverseOrders: [
      {
        // serialNumber: 1,
        authorityName: "",
        correctiveActionTaken: "",
        caseBrief: "",
      },
    ],
    beneficiariesOfCSRProjects: [
      {
        // serialNumber: 1,
        csrProjectName: "",
        numberOfBeneficiaries: "",
        percentageFromVulnerableMarginalizedGroups: "",
      },
    ],
    socialImpactAssessmentsDoc: [],
    csrProjectsInAspirationalDistrictsDoc: [],
    procurementPolicyDoc: [],
    traditionalKnowledgeIntellectualPropertiesDoc: [],
    correctiveActionsForAdverseOrdersDoc: [],
    beneficiariesOfCSRProjectsDoc: [],
  });

  // const handleRemoveRow = (rowIndex) => {
  //   setFormData((prevState) => {
  //     const updatedTable = [...prevState.socialImpactAssessments];
  //     updatedTable.splice(rowIndex, 1);

  //     const updatedTable1 = [...prevState.csrProjectsInAspirationalDistricts];
  //     updatedTable1.splice(rowIndex, 1);

  //     const updatedTable2 = [
  //       ...prevState.traditionalKnowledgeIntellectualProperties,
  //     ];
  //     updatedTable2.splice(rowIndex, 1);

  //     const updatedTable3 = [...prevState.correctiveActionsForAdverseOrders];
  //     updatedTable3.splice(rowIndex, 1);

  //     const updatedTable4 = [...prevState.beneficiariesOfCSRProjects];
  //     updatedTable4.splice(rowIndex, 1);
  //     // Update the serial numbers of the remaining rows
  //     const updatedTableWithSerialNumbers = updatedTable.map((row, index) => ({
  //       ...row,
  //       serialNumber: index + 1,
  //     }));

  //     const updatedTableWithSerialNumbers1 = updatedTable1.map(
  //       (row, index) => ({
  //         ...row,
  //         serialNumber: index + 1,
  //       })
  //     );
  //     const updatedTableWithSerialNumbers2 = updatedTable2.map(
  //       (row, index) => ({
  //         ...row,
  //         serialNumber: index + 1,
  //       })
  //     );

  //     const updatedTableWithSerialNumbers3 = updatedTable3.map(
  //       (row, index) => ({
  //         ...row,
  //         serialNumber: index + 1,
  //       })
  //     );

  //     const updatedTableWithSerialNumbers4 = updatedTable4.map(
  //       (row, index) => ({
  //         ...row,
  //         serialNumber: index + 1,
  //       })
  //     );
  //     // setOpenDialog(true);
  //     // setFieldToRemove({rowIndex });

  //     return {
  //       ...prevState,
  //       socialImpactAssessments: updatedTableWithSerialNumbers,
  //       csrProjectsInAspirationalDistricts: updatedTableWithSerialNumbers1,
  //       traditionalKnowledgeIntellectualProperties:
  //         updatedTableWithSerialNumbers2,
  //       correctiveActionsForAdverseOrders: updatedTableWithSerialNumbers3,
  //       beneficiariesOfCSRProjects: updatedTableWithSerialNumbers4,
  //     };
  //   });
  // };

  const handleDeleteClick = (rowIndex, tableField) => {
    const rowData = formData[tableField][rowIndex];

    // Ignore serialNumber when checking for filled data
    const hasData = Object.entries(rowData).some(
      ([key, val]) =>
        key !== "serialNumber" && val !== "" && val !== null && val !== false,
    );

    if (hasData) {
      setRowToDelete({ index: rowIndex, table: tableField });
      setOpenDialog(true);
    } else {
      // If only serialNumber is filled or all fields are empty, delete directly
      deleteRow(rowIndex, tableField);
    }
  };

  const deleteRow = (rowIndex, tableField) => {
    setFormData((prev) => {
      const updatedTable = [...prev[tableField]];
      updatedTable.splice(rowIndex, 1);
      const updatedTableWithSerialNumbers = updatedTable.map((row, index) => ({
        ...row,
        serialNumber: index + 1,
      }));
      return { ...prev, [tableField]: updatedTableWithSerialNumbers };
    });
  };

  const confirmDelete = () => {
    if (rowToDelete.index !== null && rowToDelete.table) {
      deleteRow(rowToDelete.index, rowToDelete.table);
    }
    setOpenDialog(false);
    setRowToDelete({ index: null, table: null });
  };

  const cancelDelete = () => {
    setOpenDialog(false);
    setRowToDelete({ index: null, table: null });
  };

  const handleTableChange = (tableField, rowIndex, key, value, type) => {
    if (type === "number" && !/^\d*$/.test(value)) return;
    if (type === "percentage") {
      // Allow only numbers and optional decimals
      if (!/^\d*\.?\d*$/.test(value)) return;

      // Convert value to a number and restrict range
      if (Number(value) < 0 || Number(value) > 100) return;
    }
    setFormData((prevState) => {
      const updatedTable = [...prevState[tableField]];
      updatedTable[rowIndex] = { ...updatedTable[rowIndex], [key]: value };
      return { ...prevState, [tableField]: updatedTable };
    });
  };

  const addRowToTable = (tableField, defaultRow) => {
    setFormData((prevState) => ({
      ...prevState,
      [tableField]: [...prevState[tableField], defaultRow],
    }));
  };

  const socialImpactColumns = [
    { label: "S.No", field: "serialNumber", type: "static" },
    {
      label: "Details of negative social impact identified",
      field: "details",
      type: "text",
    },
    {
      label: "Corrective action taken",
      field: "correctiveActionTaken",
      type: "text",
    },
  ];

  const csrColumns = [
    { label: "S.No", field: "serialNumber", type: "static" },
    { label: "State", field: "state", type: "text" },
    {
      label: "Aspirational District",
      field: "aspirationalDistrict",
      type: "text",
    },
    { label: "Amount spent (In INR)", field: "amountSpent", type: "number" },
  ];

  const intellectColumns = [
    { label: "S.No", field: "serialNumber", type: "static" },
    {
      label: "Intellectual Property based on traditional knowledge",
      field: "ipBasedOnTraditionalKnowledge",
      type: "text",
    },
    {
      label: "Owned/Acquired (Yes / No)",
      field: "ownedAcquired",
      type: "select",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    {
      label: "Benefit shared (Yes / No)",
      field: "benefitShared",
      type: "select",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    {
      label: "Basis of calculating benefit share",
      field: "basisOfCalculatingBenefitShare",
      type: "text",
    },
  ];

  const correctiveActionColumns = [
    { label: "S.No", field: "serialNumber", type: "static" },
    {
      label: "Name of authority",
      field: "authorityName",
      type: "text",
    },
    {
      label: "Brief of the Case",
      field: "correctiveActionTaken",
      type: "text",
    },
    { label: "Corrective action taken", field: "caseBrief", type: "text" },
  ];

  const benificiariesColumns = [
    { label: "S.No", field: "serialNumber", type: "static" },
    {
      label: "CSR Project",
      field: "csrProjectName",
      type: "text",
    },
    {
      label: "No. of persons benefitted from CSR projects",
      field: "numberOfBeneficiaries",
      type: "number",
    },
    {
      label: "% of beneficiaries from vulnerable and marginalised groups",
      field: "percentageFromVulnerableMarginalizedGroups",
      type: "percentage",
    },
  ];

  const fetchData = async () => {
    const res = await get(
      `/brsr/get?subType=principle8&type=SectionC&id=${id}`,
    );
    if (
      res?.data?.data?.year
        ? res?.data?.data?.year < currentYear - 1
        : false || !brsrReview
    )
      setDisabled(true);

    const res1 = res?.data?.data?.BRSRSectionC?.principle8?.leadershipIndicator;
    setFormData((prev) => ({
      ...prev,
      ...res1,
      socialImpactAssessments:
        res1?.socialImpactAssessments?.length > 0
          ? res1?.socialImpactAssessments
          : prev?.socialImpactAssessments,
      procurementPolicy: {
        action: res1?.procurementPolicy?.action ?? "yes",
        vulnerableGoupProcure:
          res1?.procurementPolicy?.vulnerableGoupProcure ?? "",
        totalProcurementByValue:
          res1?.procurementPolicy?.totalProcurementByValue ?? "",
      },
      csrProjectsInAspirationalDistricts:
        res1?.csrProjectsInAspirationalDistricts.length > 0
          ? res1?.csrProjectsInAspirationalDistricts
          : prev?.csrProjectsInAspirationalDistricts,

      traditionalKnowledgeIntellectualProperties:
        res1?.traditionalKnowledgeIntellectualProperties.length > 0
          ? res1?.traditionalKnowledgeIntellectualProperties
          : prev?.traditionalKnowledgeIntellectualProperties,

      correctiveActionsForAdverseOrders:
        res1?.correctiveActionsForAdverseOrders.length > 0
          ? res1?.correctiveActionsForAdverseOrders
          : prev?.correctiveActionsForAdverseOrders,
      beneficiariesOfCSRProjects:
        res1?.beneficiariesOfCSRProjects.length > 0
          ? res1?.beneficiariesOfCSRProjects
          : prev?.beneficiariesOfCSRProjects,
      socialImpactAssessmentsDoc: res1?.socialImpactAssessmentsDoc ?? [],
      csrProjectsInAspirationalDistrictsDoc:
        res1?.csrProjectsInAspirationalDistrictsDoc ?? [],
      procurementPolicyDoc: res1?.procurementPolicyDoc ?? [],
      traditionalKnowledgeIntellectualPropertiesDoc:
        res1?.traditionalKnowledgeIntellectualPropertiesDoc ?? [],
      correctiveActionsForAdverseOrdersDoc:
        res1?.correctiveActionsForAdverseOrdersDoc ?? [],
      beneficiariesOfCSRProjectsDoc: res1?.beneficiariesOfCSRProjectsDoc ?? [],
    }));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async () => {
    // if (!validateForm()) {
    //   console.warn("Validation failed!", errors);
    //   return; // ✅ Stop submission if validation fails
    // }
    if (!disabled) {
      let transformedData = {
        leadershipIndicator: {
          ...formData,
        },
        leadershipIndicatorSubmitted: true,
        type: "SectionC",
        subType: "principle8",
      };
      await put(`/brsr/update?id=${id}`, transformedData)
        .then((res) => {
          navigate(`/brsr/section-c/principle9/${id}`);
        })
        .catch((err) => {});
    } else navigate(`/brsr/section-c/principle9/${id}`);
  };

  return (
    <>
      <DeleteRowDialog
        openDialog={openDialog}
        cancelRemoveRow={cancelDelete}
        confirmRemoveRow={confirmDelete}
      />
      <Box>
        <p className={style.subHeading}>II. LEADERSHIP INDICATOR</p>
        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            1. Provide details of actions taken to mitigate any negative social
            impacts identified in the Social Impact Assessments (Reference:
            Question 1 of Essential Indicators above):
          </p>
          <Box sx={{ ml: 1.5 }}>
            {" "}
            <DynamicTable
              data={formData.socialImpactAssessments}
              disabled={disabled}
              columns={socialImpactColumns}
              onRowChange={(rowIndex, key, value) =>
                handleTableChange(
                  "socialImpactAssessments",
                  rowIndex,
                  key,
                  value,
                )
              }
              // onDeleteRow={handleRemoveRow}
              onDeleteRow={(rowIndex) =>
                handleDeleteClick(rowIndex, "socialImpactAssessments")
              }
              onAddRow={(defaultRow) =>
                addRowToTable("socialImpactAssessments", defaultRow)
              }
              defaultRow={{
                serialNumber: formData.socialImpactAssessments.length + 1,
                details: "",
                correctiveActionTaken: "",
              }}
              hide={hide}
            />
          </Box>
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            //  errors,
            //  setErrors,
            Uploadkey: "socialImpactAssessmentsDoc",
            ml: 2,
            removeUpload,
          }}
        />
        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            2. Provide the following information on CSR projects undertaken by
            your entity in designated aspirational districts as identified by
            government bodies:
          </p>
          <Box sx={{ ml: 2 }}>
            {" "}
            <DynamicTable
              disabled={disabled}
              hide={hide}
              data={formData.csrProjectsInAspirationalDistricts}
              columns={csrColumns}
              // onDeleteRow={handleRemoveRow}
              onDeleteRow={(rowIndex) =>
                handleDeleteClick(
                  rowIndex,
                  "csrProjectsInAspirationalDistricts",
                )
              }
              onRowChange={(rowIndex, key, value, type) =>
                handleTableChange(
                  "csrProjectsInAspirationalDistricts",
                  rowIndex,
                  key,
                  value,
                  type,
                )
              }
              onAddRow={(defaultRow) =>
                addRowToTable("csrProjectsInAspirationalDistricts", defaultRow)
              }
              defaultRow={{
                serialNumber:
                  formData.csrProjectsInAspirationalDistricts.length + 1,
                state: "",
                aspirationalDistrict: "",
                amountSpent: "",
              }}
            />
          </Box>
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            //  errors,
            //  setErrors,
            Uploadkey: "csrProjectsInAspirationalDistrictsDoc",
            ml: 2,
            removeUpload,
          }}
        />
        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            3. (a) Do you have a preferential procurement policy where you give
            preference to purchase from suppliers comprising marginalized /
            vulnerable groups? (Yes / No)
          </p>
          <FormControl component="fieldset">
            <RadioGroup
              disabled={disabled}
              name="independentAssessmentStatus"
              value={
                formData?.procurementPolicy?.action === "no" ? "no" : "yes"
              }
              onChange={(e) => {
                setFormData({
                  ...formData,
                  procurementPolicy: {
                    ...formData.procurementPolicy,
                    action: e.target.value,
                    vulnerableGoupProcure:
                      e.target.value === "no"
                        ? ""
                        : formData.procurementPolicy.vulnerableGoupProcure,
                    totalProcurementByValue:
                      e.target.value === "no"
                        ? ""
                        : formData.procurementPolicy.totalProcurementByValue,
                  },
                });
              }}
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "10px",
                marginTop: "-10px",
                margin: "-10px 0px 10px 15px",
              }}
            >
              <FormControlLabel
                value="yes"
                control={<Radio disabled={disabled} />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={<Radio disabled={disabled} />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
          {formData.procurementPolicy.action === "yes" ? (
            <>
              <p className={styles.question_title}>
                3. (b) From which marginalized / vulnerable groups do you
                procure?
              </p>
              <TextField
                multiline
                disabled={disabled}
                minRows={1}
                style={{
                  width: "50%",
                  marginTop: "-0.5rem",
                  marginBottom: "1rem",
                  marginLeft: "1rem",
                }}
                size="small"
                placeholder="Enter Name Here"
                value={formData.procurementPolicy.vulnerableGoupProcure}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    procurementPolicy: {
                      ...formData.procurementPolicy,
                      vulnerableGoupProcure: e.target.value,
                    },
                  })
                }
              />
              <p className={styles.question_title}>
                3. (c) What percentage of total procurement (by value) does it
                constitute?
              </p>
              <TextField
                disabled={disabled}
                style={{
                  width: "50%",
                  marginTop: "-0.5rem",
                  marginLeft: "1rem",
                }}
                size="small"
                placeholder="Enter % Here"
                value={formData.procurementPolicy.totalProcurementByValue}
                onChange={(e) => {
                  const value = e.target.value;
                  if (
                    !/^\d*\.?\d*$/.test(value) ||
                    Number(value) < 0 ||
                    Number(value) > 100
                  )
                    return;
                  setFormData({
                    ...formData,
                    procurementPolicy: {
                      ...formData.procurementPolicy,
                      totalProcurementByValue: e.target.value,
                    },
                  });
                }}
              />
            </>
          ) : null}
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            //  errors,
            //  setErrors,
            Uploadkey: "procurementPolicyDoc",
            ml: 2,
            removeUpload,
          }}
        />
        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            4. Details of the benefits derived and shared from the intellectual
            properties owned or acquired by your entity (in the current
            financial year), based on traditional knowledge:
          </p>
          <Box sx={{ ml: 2 }}>
            <DynamicTable
              disabled={disabled}
              hide={hide}
              data={formData.traditionalKnowledgeIntellectualProperties}
              columns={intellectColumns}
              // onDeleteRow={handleRemoveRow}
              onDeleteRow={(rowIndex) =>
                handleDeleteClick(
                  rowIndex,
                  "traditionalKnowledgeIntellectualProperties",
                )
              }
              onRowChange={(rowIndex, key, value, type) =>
                handleTableChange(
                  "traditionalKnowledgeIntellectualProperties",
                  rowIndex,
                  key,
                  value,
                  type,
                )
              }
              onAddRow={(defaultRow) =>
                addRowToTable(
                  "traditionalKnowledgeIntellectualProperties",
                  defaultRow,
                )
              }
              defaultRow={{
                serialNumber:
                  formData.traditionalKnowledgeIntellectualProperties.length +
                  1,
                ipBasedOnTraditionalKnowledge: "",
                ownedAcquired: "",
                benefitShared: "",
                basisOfCalculatingBenefitShare: "",
              }}
            />
          </Box>
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            //  errors,
            //  setErrors,
            Uploadkey: "traditionalKnowledgeIntellectualPropertiesDoc",
            ml: 2,
            removeUpload,
          }}
        />
        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            5. Details of corrective actions taken or underway, based on any
            adverse order in intellectual property related disputes wherein
            usage of traditional knowledge is involved.
          </p>
          <Box sx={{ ml: 2 }}>
            <DynamicTable
              disabled={disabled}
              hide={hide}
              data={formData.correctiveActionsForAdverseOrders}
              columns={correctiveActionColumns}
              // onDeleteRow={handleRemoveRow}
              onDeleteRow={(rowIndex) =>
                handleDeleteClick(rowIndex, "correctiveActionsForAdverseOrders")
              }
              onRowChange={(rowIndex, key, value, type) =>
                handleTableChange(
                  "correctiveActionsForAdverseOrders",
                  rowIndex,
                  key,
                  value,
                  type,
                )
              }
              onAddRow={(defaultRow) =>
                addRowToTable("correctiveActionsForAdverseOrders", defaultRow)
              }
              defaultRow={{
                serialNumber:
                  formData.correctiveActionsForAdverseOrders.length + 1,
                authorityName: "",
                correctiveActionTaken: "",
                caseBrief: "",
              }}
            />
          </Box>
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            //  errors,
            //  setErrors,
            Uploadkey: "correctiveActionsForAdverseOrdersDoc",
            ml: 2,
            removeUpload,
          }}
        />
        <Box sx={{ mb: 3 }}>
          <p className={styles.question_title}>
            6. Details of beneficiaries of CSR Projects:
          </p>
          <Box sx={{ ml: 2 }}>
            <DynamicTable
              disabled={disabled}
              hide={hide}
              data={formData.beneficiariesOfCSRProjects}
              columns={benificiariesColumns}
              // onDeleteRow={handleRemoveRow}
              onDeleteRow={(rowIndex) =>
                handleDeleteClick(rowIndex, "beneficiariesOfCSRProjects")
              }
              onRowChange={(rowIndex, key, value, type) =>
                handleTableChange(
                  "beneficiariesOfCSRProjects",
                  rowIndex,
                  key,
                  value,
                  type,
                )
              }
              onAddRow={(defaultRow) =>
                addRowToTable("beneficiariesOfCSRProjects", defaultRow)
              }
              defaultRow={{
                serialNumber: formData.beneficiariesOfCSRProjects.length + 1,
                csrProjectName: "",
                numberOfBeneficiaries: "",
                percentageFromVulnerableMarginalizedGroups: "",
              }}
            />
          </Box>
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            //  errors,
            //  setErrors,
            Uploadkey: "beneficiariesOfCSRProjectsDoc",
            ml: 2,
            removeUpload,
          }}
        />
        {!hide && (
          <>
            {brsrReview ? (
              <Box sx={{ width: "98.5%", ml: 2 }}>
                <ReviewBox
                  url={`/brsr/review/${id}`}
                  handleSubmit={handleSubmit}
                />
              </Box>
            ) : (
              <div style={{ textAlign: "right", marginBottom: "2rem" }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  className={styles.submit_button}
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <ArrowForwardIcon sx={{ ml: 1 }} />
                </Button>
              </div>
            )}
          </>
        )}
      </Box>
    </>
  );
};

export default LeadershipIndicator;
